export default [
  {
    path: '/app/projects',
    name: 'Projects',
    component: () => import('@/views/Projects/Index.vue'),
    meta: {
      navActiveLink: 'Projects',
      pageTitle: 'nav.projects',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
      resource: 'PROJECTS_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/projects/add',
    name: 'ProjectsAdd',
    component: () => import('@/views/Projects/Add.vue'),
    meta: {
      navActiveLink: 'Projects',
      pageTitle: 'nav.projects',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/app/projects',
          active: false,
        },
        {
          text: 'breadcrumb.create',
          active: true,
        },
      ],
      resource: 'PROJECTS_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/projects/detail/:id',
    name: 'ProjectsDetail',
    component: () => import('@/views/Projects/Detail.vue'),
    meta: {
      navActiveLink: 'Projects',
      pageTitle: 'nav.projects',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/app/projects',
          active: false,
        },
        {
          text: 'breadcrumb.detail',
          active: true,
        },
      ],
      resource: 'PROJECTS_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/projects/edit/:id',
    name: 'ProjectsEdit',
    component: () => import('@/views/Projects/Edit.vue'),
    meta: {
      navActiveLink: 'Projects',
      pageTitle: 'nav.projects',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/app/projects',
          active: false,
        },
        {
          text: 'breadcrumb.update',
          active: true,
        },
      ],
      resource: 'PROJECTS_EDIT',
      action: 'read',
    },
  },
]
